import React, { useState } from 'react';
import { Layout } from '../Layout';
import { ScoreDetails } from './ScoreDetails';
import ExpandableSection from '@cloudscape-design/components/expandable-section';
import SpaceBetween from '@cloudscape-design/components/space-between';
import FormField from '@cloudscape-design/components/form-field';
import Select from '@cloudscape-design/components/select';
import { OptionDefinition } from '@cloudscape-design/components/internal/components/option/interfaces';
import Form from '@cloudscape-design/components/form';
import Button from '@cloudscape-design/components/button';
import Alert from '@cloudscape-design/components/alert';
import { eventsList, gradesList } from 'src/utils/constant';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getApiHeader } from 'src/utils';
import { EventData } from '../Events/EventStatus';

export const Scores: React.FC = () => {

    const [selectedEvent, setSelectedEvent] = useState<OptionDefinition>({ label: 'Select event', value: '' });
    const [selectedGrade, setSelectedGrade] = useState<OptionDefinition>({ label: 'Select grade', value: '' });
    const [selectedEventCategory, setSelectedEventCategory] = useState('');
    const [error, setError] = useState('');
    const [showScores, setShowScores] = useState(false);
    const headers = getApiHeader();

    const { data: eventStatusData, isLoading, refetch, fetchStatus } = useQuery({
        queryKey: [`getEventStatus-${selectedEventCategory}-${selectedGrade.value}-ScoresPage`],
        queryFn: async () => {
            const result = await axios.post('https://u3ea0uwyt4.execute-api.us-east-1.amazonaws.com/Prod/eventstatus',
                {
                    eventCategory: selectedEventCategory,
                    Grade: selectedGrade.value,
                },
                {
                    headers
                });
            return result?.data?.result?.[0] as EventData;
        },
        staleTime: 0,
    });

    const reset = (showScore: boolean) => {
        setError('');
        setShowScores(showScore);
    }

    const getScores = () => {
        if (!selectedEvent.value || !selectedGrade.value) {
            setError('Please select event cateory and grade to continue');
            setShowScores(false);
        } else if (!eventStatusData || eventStatusData.status !== 'Started') {
            setError('Please start the event to start entering scores');
            setShowScores(false);
        } else {
            reset(true);
        }
    }

    return (
        <Layout breadcrumbs={[
            {
                href: '/scores',
                text: 'Scores'
            }
        ]}>
            <SpaceBetween direction="vertical" size="l">
                {
                    error && (
                        <Alert header="Validation error" type='error'>{error}</Alert>
                    )
                }
                <ExpandableSection
                    defaultExpanded
                    variant="container"
                    headerText="Search"
                >
                    <Form
                        actions={
                            <SpaceBetween direction="horizontal" size="xs">
                                <Button formAction="none" variant="link" onClick={() => reset(false)}>
                                    Clear
                                </Button>
                                <Button variant="primary" onClick={getScores}>Search</Button>
                            </SpaceBetween>
                        }>
                        <SpaceBetween direction="horizontal" size="l">
                            <FormField label="Event category">
                                <Select
                                    selectedOption={selectedEvent}
                                    onChange={({ detail }) => {
                                        setSelectedEvent(detail.selectedOption);
                                        setSelectedEventCategory(detail.selectedOption.label!);
                                        reset(false);
                                    }}
                                    options={eventsList.map((event) => ({
                                        label: event.name, value: event.id
                                    }))}
                                />
                            </FormField>
                            <FormField label="Grade">
                                <Select
                                    selectedOption={selectedGrade}
                                    onChange={({ detail }) => {
                                        setSelectedGrade(detail.selectedOption);
                                        reset(false);
                                    }
                                    }
                                    options={gradesList.map((grade) => ({
                                        label: grade, value: grade
                                    }))} />
                            </FormField>
                        </SpaceBetween>
                    </Form>
                </ExpandableSection>
                {
                    showScores && <ScoreDetails eventID={selectedEvent.value!} eventCategory={selectedEventCategory!} grade={selectedGrade.value!} />
                }
            </SpaceBetween>
        </Layout>
    )
};